/**
 * NEON COACH - قائمة الأصناف الـ 121 المعتمدة (121 Curated Foods)
 * مدققة بالكامل بقيم السعرات والماكروز والألياف لكل 100غ
 */

export const CURATED_121_FOODS = [
  {
    "id": "F006",
    "nameAr": "دجاج مفروم",
    "nameEn": "Ground chicken",
    "state": "نيء",
    "caloriesPer100g": 143,
    "proteinPer100g": 17.4,
    "carbsPer100g": 0,
    "fatsPer100g": 8.1,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F007",
    "nameAr": "صدر حبش مطبوخ",
    "nameEn": "Turkey breast, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 135,
    "proteinPer100g": 29.9,
    "carbsPer100g": 0,
    "fatsPer100g": 1.8,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F008",
    "nameAr": "صدر حبش/تركي مدخن",
    "nameEn": "Smoked turkey breast",
    "state": "جاهز للأكل",
    "caloriesPer100g": 104,
    "proteinPer100g": 17.1,
    "carbsPer100g": 3.5,
    "fatsPer100g": 2,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F002",
    "nameAr": "صدر دجاج مطبوخ بدون جلد",
    "nameEn": "Chicken breast, cooked, skinless",
    "state": "مطبوخ",
    "caloriesPer100g": 165,
    "proteinPer100g": 31,
    "carbsPer100g": 0,
    "fatsPer100g": 3.6,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F005",
    "nameAr": "فخذ دجاج مطبوخ بدون جلد",
    "nameEn": "Chicken thigh, cooked, skinless",
    "state": "مطبوخ",
    "caloriesPer100g": 209,
    "proteinPer100g": 26,
    "carbsPer100g": 0,
    "fatsPer100g": 10.9,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F004",
    "nameAr": "فخذ دجاج نيء بدون جلد",
    "nameEn": "Chicken thigh, raw, skinless",
    "state": "نيء",
    "caloriesPer100g": 135,
    "proteinPer100g": 19.7,
    "carbsPer100g": 0,
    "fatsPer100g": 5.8,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F009",
    "nameAr": "لانشون تركي",
    "nameEn": "Turkey deli meat",
    "state": "جاهز للأكل",
    "caloriesPer100g": 110,
    "proteinPer100g": 17,
    "carbsPer100g": 4,
    "fatsPer100g": 2.5,
    "fiberPer100g": 0,
    "category": "دجاج وطيور",
    "allergens": []
  },
  {
    "id": "F012",
    "nameAr": "كتف عجل نيء",
    "nameEn": "Veal shoulder, raw",
    "state": "نيء",
    "caloriesPer100g": 180,
    "proteinPer100g": 20,
    "carbsPer100g": 0,
    "fatsPer100g": 10.5,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F018",
    "nameAr": "كفتة لحم",
    "nameEn": "Meat kofta",
    "state": "مطبوخ",
    "caloriesPer100g": 250,
    "proteinPer100g": 18,
    "carbsPer100g": 3,
    "fatsPer100g": 18,
    "fiberPer100g": 0.5,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F013",
    "nameAr": "لحم بقري قليل الدهن مطبوخ",
    "nameEn": "Lean beef, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 220,
    "proteinPer100g": 29,
    "carbsPer100g": 0,
    "fatsPer100g": 11,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F015",
    "nameAr": "لحم بقري مفروم 10% دهون مطبوخ",
    "nameEn": "Ground beef 90/10, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 217,
    "proteinPer100g": 26.1,
    "carbsPer100g": 0,
    "fatsPer100g": 11.8,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F014",
    "nameAr": "لحم بقري مفروم 10% دهون نيء",
    "nameEn": "Ground beef 90/10, raw",
    "state": "نيء",
    "caloriesPer100g": 176,
    "proteinPer100g": 20,
    "carbsPer100g": 0,
    "fatsPer100g": 10,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F017",
    "nameAr": "لحم بقري مفروم 20% دهون مطبوخ",
    "nameEn": "Ground beef 80/20, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 272,
    "proteinPer100g": 25.4,
    "carbsPer100g": 0,
    "fatsPer100g": 17.4,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F016",
    "nameAr": "لحم بقري مفروم 20% دهون نيء",
    "nameEn": "Ground beef 80/20, raw",
    "state": "نيء",
    "caloriesPer100g": 254,
    "proteinPer100g": 17.2,
    "carbsPer100g": 0,
    "fatsPer100g": 20,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F011",
    "nameAr": "لحم عجل مطبوخ قليل الدهن",
    "nameEn": "Veal, lean, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 229,
    "proteinPer100g": 30.1,
    "carbsPer100g": 0,
    "fatsPer100g": 11.3,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F010",
    "nameAr": "لحم عجل نيء قليل الدهن",
    "nameEn": "Veal, lean, raw",
    "state": "نيء",
    "caloriesPer100g": 172,
    "proteinPer100g": 20.7,
    "carbsPer100g": 0,
    "fatsPer100g": 8.5,
    "fiberPer100g": 0,
    "category": "لحوم",
    "allergens": []
  },
  {
    "id": "F020",
    "nameAr": "تونة بالماء غير مصفاة",
    "nameEn": "Tuna canned in water",
    "state": "معلبة",
    "caloriesPer100g": 100,
    "proteinPer100g": 22,
    "carbsPer100g": 0,
    "fatsPer100g": 0.7,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish"
    ]
  },
  {
    "id": "F019",
    "nameAr": "تونة بالماء مصفاة",
    "nameEn": "Tuna canned in water, drained",
    "state": "مصفاة",
    "caloriesPer100g": 116,
    "proteinPer100g": 25.5,
    "carbsPer100g": 0,
    "fatsPer100g": 0.8,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish"
    ]
  },
  {
    "id": "F024",
    "nameAr": "سلمون مدخن",
    "nameEn": "Smoked salmon",
    "state": "مدخن",
    "caloriesPer100g": 117,
    "proteinPer100g": 18.3,
    "carbsPer100g": 0,
    "fatsPer100g": 4.3,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish"
    ]
  },
  {
    "id": "F023",
    "nameAr": "سمك أبيض مشوي",
    "nameEn": "White fish, grilled",
    "state": "مشوي",
    "caloriesPer100g": 120,
    "proteinPer100g": 24,
    "carbsPer100g": 0,
    "fatsPer100g": 2.5,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish",
      "eggs"
    ]
  },
  {
    "id": "F022",
    "nameAr": "سمك دنيس مشوي",
    "nameEn": "Sea bream, grilled",
    "state": "مشوي",
    "caloriesPer100g": 120,
    "proteinPer100g": 23,
    "carbsPer100g": 0,
    "fatsPer100g": 3,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish"
    ]
  },
  {
    "id": "F021",
    "nameAr": "سمك دنيس نيء",
    "nameEn": "Sea bream, raw",
    "state": "نيء",
    "caloriesPer100g": 96,
    "proteinPer100g": 20.5,
    "carbsPer100g": 0,
    "fatsPer100g": 1.9,
    "fiberPer100g": 0,
    "category": "أسماك",
    "allergens": [
      "fish"
    ]
  },
  {
    "id": "F026",
    "nameAr": "بياض البيض",
    "nameEn": "Egg white",
    "state": "نيء/قياسي",
    "caloriesPer100g": 52,
    "proteinPer100g": 10.9,
    "carbsPer100g": 0.7,
    "fatsPer100g": 0.2,
    "fiberPer100g": 0,
    "category": "بيض",
    "isCountBased": true,
    "pieceWeight": 33,
    "unitLabel": "بياض بيض",
    "unitName": "بياض بيض",
    "allergens": [
      "eggs"
    ]
  },
  {
    "id": "F025",
    "nameAr": "بيض كامل",
    "nameEn": "Whole egg",
    "state": "نيء/قياسي",
    "caloriesPer100g": 143,
    "proteinPer100g": 12.6,
    "carbsPer100g": 0.7,
    "fatsPer100g": 9.5,
    "fiberPer100g": 0,
    "category": "بيض",
    "isCountBased": true,
    "pieceWeight": 50,
    "unitLabel": "بيضة كاملة",
    "unitName": "بيضة كاملة",
    "allergens": [
      "eggs"
    ]
  },
  {
    "id": "F027",
    "nameAr": "صفار البيض",
    "nameEn": "Egg yolk",
    "state": "نيء/قياسي",
    "caloriesPer100g": 322,
    "proteinPer100g": 15.9,
    "carbsPer100g": 3.6,
    "fatsPer100g": 26.5,
    "fiberPer100g": 0,
    "category": "بيض",
    "isCountBased": true,
    "pieceWeight": 17,
    "unitLabel": "صفار بيض",
    "unitName": "صفار بيض",
    "allergens": [
      "eggs"
    ]
  },
  {
    "id": "F036",
    "nameAr": "جبنة Adam's",
    "nameEn": "Adam's-style cheese",
    "state": "جاهز",
    "caloriesPer100g": 300,
    "proteinPer100g": 18,
    "carbsPer100g": 4,
    "fatsPer100g": 24,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F038",
    "nameAr": "جبنة بارميزان",
    "nameEn": "Parmesan cheese",
    "state": "جاهز",
    "caloriesPer100g": 431,
    "proteinPer100g": 38,
    "carbsPer100g": 4.1,
    "fatsPer100g": 29,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F031",
    "nameAr": "جبنة حلوم",
    "nameEn": "Halloumi cheese",
    "state": "جاهز",
    "caloriesPer100g": 321,
    "proteinPer100g": 22,
    "carbsPer100g": 2.2,
    "fatsPer100g": 25,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F037",
    "nameAr": "جبنة شيدر",
    "nameEn": "Cheddar cheese",
    "state": "جاهز",
    "caloriesPer100g": 403,
    "proteinPer100g": 24.9,
    "carbsPer100g": 1.3,
    "fatsPer100g": 33.1,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F032",
    "nameAr": "جبنة عكاوي",
    "nameEn": "Akkawi cheese",
    "state": "جاهز",
    "caloriesPer100g": 300,
    "proteinPer100g": 20,
    "carbsPer100g": 3,
    "fatsPer100g": 23,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F030",
    "nameAr": "جبنة فيتا",
    "nameEn": "Feta cheese",
    "state": "جاهز",
    "caloriesPer100g": 265,
    "proteinPer100g": 14.2,
    "carbsPer100g": 3.9,
    "fatsPer100g": 21.5,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F033",
    "nameAr": "جبنة كريمية",
    "nameEn": "Cream cheese",
    "state": "جاهز",
    "caloriesPer100g": 342,
    "proteinPer100g": 6.2,
    "carbsPer100g": 4.1,
    "fatsPer100g": 34.4,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F035",
    "nameAr": "جبنة كريمية Kiri",
    "nameEn": "Kiri-style cream cheese",
    "state": "جاهز",
    "caloriesPer100g": 300,
    "proteinPer100g": 8,
    "carbsPer100g": 4,
    "fatsPer100g": 28,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F034",
    "nameAr": "جبنة كريمية لايت",
    "nameEn": "Light cream cheese",
    "state": "جاهز",
    "caloriesPer100g": 200,
    "proteinPer100g": 10,
    "carbsPer100g": 6,
    "fatsPer100g": 15,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F029",
    "nameAr": "جبنة موزاريلا قليلة الدسم",
    "nameEn": "Mozzarella, part-skim",
    "state": "جاهز",
    "caloriesPer100g": 254,
    "proteinPer100g": 24.3,
    "carbsPer100g": 2.8,
    "fatsPer100g": 15.9,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F028",
    "nameAr": "جبنة موزاريلا كاملة الدسم",
    "nameEn": "Mozzarella, whole milk",
    "state": "جاهز",
    "caloriesPer100g": 280,
    "proteinPer100g": 27.5,
    "carbsPer100g": 3.1,
    "fatsPer100g": 17.1,
    "fiberPer100g": 0,
    "category": "أجبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F044",
    "nameAr": "حليب Baladna خالي الدسم",
    "nameEn": "Baladna skimmed milk",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 34,
    "proteinPer100g": 3.4,
    "carbsPer100g": 5,
    "fatsPer100g": 0.1,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F046",
    "nameAr": "حليب بودرة خالي الدسم",
    "nameEn": "Skim milk powder",
    "state": "مسحوق",
    "caloriesPer100g": 360,
    "proteinPer100g": 36,
    "carbsPer100g": 52,
    "fatsPer100g": 0.8,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F043",
    "nameAr": "حليب خالي الدسم",
    "nameEn": "Skim milk",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 34,
    "proteinPer100g": 3.4,
    "carbsPer100g": 5,
    "fatsPer100g": 0.1,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F045",
    "nameAr": "حليب قليل الدسم",
    "nameEn": "Low-fat milk",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 42,
    "proteinPer100g": 3.4,
    "carbsPer100g": 5,
    "fatsPer100g": 1,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F041",
    "nameAr": "زبادي بروتين",
    "nameEn": "Protein yogurt",
    "state": "جاهز",
    "caloriesPer100g": 65,
    "proteinPer100g": 10,
    "carbsPer100g": 4,
    "fatsPer100g": 0.5,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F039",
    "nameAr": "زبادي كامل الدسم طبيعي",
    "nameEn": "Plain whole-milk yogurt",
    "state": "جاهز",
    "caloriesPer100g": 61,
    "proteinPer100g": 3.5,
    "carbsPer100g": 4.7,
    "fatsPer100g": 3.3,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F042",
    "nameAr": "زبادي يوناني YoPRO Triple Zero",
    "nameEn": "YoPRO Triple Zero Greek Yogurt",
    "state": "جاهز",
    "caloriesPer100g": 60,
    "proteinPer100g": 10,
    "carbsPer100g": 4,
    "fatsPer100g": 0.5,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F040",
    "nameAr": "زبادي يوناني خالي الدسم",
    "nameEn": "Greek yogurt, nonfat",
    "state": "جاهز",
    "caloriesPer100g": 59,
    "proteinPer100g": 10.3,
    "carbsPer100g": 3.6,
    "fatsPer100g": 0.4,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F051",
    "nameAr": "كريمة حليب 30%",
    "nameEn": "Dairy cream 30% fat",
    "state": "كريمة",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 292,
    "proteinPer100g": 2.1,
    "carbsPer100g": 3,
    "fatsPer100g": 30,
    "fiberPer100g": 0,
    "category": "ألبان",
    "allergens": [
      "dairy"
    ]
  },
  {
    "id": "F049",
    "nameAr": "حليب جوز الهند المعلب",
    "nameEn": "Canned coconut milk",
    "state": "سائل كثيف",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 230,
    "proteinPer100g": 2.3,
    "carbsPer100g": 5.5,
    "fatsPer100g": 23.8,
    "fiberPer100g": 2.2,
    "category": "بدائل ألبان",
    "allergens": [
      "dairy",
      "nuts"
    ]
  },
  {
    "id": "F048",
    "nameAr": "حليب جوز الهند مشروب غير محلى",
    "nameEn": "Unsweetened coconut milk beverage",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 20,
    "proteinPer100g": 0.2,
    "carbsPer100g": 0.5,
    "fatsPer100g": 1.9,
    "fiberPer100g": 0,
    "category": "بدائل ألبان",
    "allergens": [
      "dairy",
      "nuts"
    ]
  },
  {
    "id": "F047",
    "nameAr": "حليب لوز غير محلى",
    "nameEn": "Unsweetened almond milk",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 13,
    "proteinPer100g": 0.4,
    "carbsPer100g": 0.3,
    "fatsPer100g": 1.1,
    "fiberPer100g": 0.2,
    "category": "بدائل ألبان",
    "allergens": [
      "dairy",
      "nuts"
    ]
  },
  {
    "id": "F050",
    "nameAr": "كريمة جوز الهند",
    "nameEn": "Coconut cream",
    "state": "كريمة",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 330,
    "proteinPer100g": 3.6,
    "carbsPer100g": 6.7,
    "fatsPer100g": 34.7,
    "fiberPer100g": 2.2,
    "category": "بدائل ألبان",
    "allergens": [
      "dairy",
      "nuts"
    ]
  },
  {
    "id": "F053",
    "nameAr": "بروتين واي BioTechUSA Iso Whey Zero فانيلا",
    "nameEn": "BioTechUSA Iso Whey Zero Vanilla",
    "state": "مسحوق",
    "caloriesPer100g": 373,
    "proteinPer100g": 86,
    "carbsPer100g": 2.9,
    "fatsPer100g": 1.9,
    "fiberPer100g": 0,
    "category": "مكملات بروتين",
    "allergens": []
  },
  {
    "id": "F052",
    "nameAr": "بروتين واي SynPro شوكولاتة",
    "nameEn": "SynPro Whey Chocolate",
    "state": "مسحوق",
    "caloriesPer100g": 383.3,
    "proteinPer100g": 77,
    "carbsPer100g": 7.7,
    "fatsPer100g": 6,
    "fiberPer100g": 0,
    "category": "مكملات بروتين",
    "allergens": []
  },
  {
    "id": "F054",
    "nameAr": "جيلاتين بقري جاف",
    "nameEn": "Beef gelatin powder",
    "state": "مسحوق",
    "caloriesPer100g": 335,
    "proteinPer100g": 85.6,
    "carbsPer100g": 0,
    "fatsPer100g": 0.1,
    "fiberPer100g": 0,
    "category": "مكملات/مكونات",
    "allergens": []
  },
  {
    "id": "F056",
    "nameAr": "زبدة",
    "nameEn": "Butter",
    "state": "جاهز",
    "caloriesPer100g": 717,
    "proteinPer100g": 0.9,
    "carbsPer100g": 0.1,
    "fatsPer100g": 81.1,
    "fiberPer100g": 0,
    "category": "دهون وزيوت",
    "allergens": []
  },
  {
    "id": "F057",
    "nameAr": "زبدة Lurpak",
    "nameEn": "Lurpak-style butter",
    "state": "جاهز",
    "caloriesPer100g": 717,
    "proteinPer100g": 0.9,
    "carbsPer100g": 0.1,
    "fatsPer100g": 81.1,
    "fiberPer100g": 0,
    "category": "دهون وزيوت",
    "allergens": []
  },
  {
    "id": "F059",
    "nameAr": "زيت جوز الهند",
    "nameEn": "Coconut oil",
    "state": "زيت",
    "unitLabel": "غ",
    "unitName": "غ",
    "unit": "g",
    "isLiquid": false,
    "caloriesPer100g": 892,
    "proteinPer100g": 0,
    "carbsPer100g": 0,
    "fatsPer100g": 100,
    "fiberPer100g": 0,
    "category": "دهون وزيوت",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F058",
    "nameAr": "سمن",
    "nameEn": "Ghee",
    "state": "جاهز",
    "caloriesPer100g": 900,
    "proteinPer100g": 0,
    "carbsPer100g": 0,
    "fatsPer100g": 100,
    "fiberPer100g": 0,
    "category": "دهون وزيوت",
    "allergens": []
  },
  {
    "id": "F068",
    "nameAr": "بذور شيا",
    "nameEn": "Chia seeds",
    "state": "جاف",
    "caloriesPer100g": 486,
    "proteinPer100g": 16.5,
    "carbsPer100g": 42.1,
    "fatsPer100g": 30.7,
    "fiberPer100g": 34.4,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F066",
    "nameAr": "جوز عين الجمل",
    "nameEn": "Walnuts",
    "state": "نيء",
    "caloriesPer100g": 654,
    "proteinPer100g": 15.2,
    "carbsPer100g": 13.7,
    "fatsPer100g": 65.2,
    "fiberPer100g": 6.7,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F069",
    "nameAr": "جوز هند مبشور غير محلى",
    "nameEn": "Unsweetened shredded coconut",
    "state": "جاف",
    "caloriesPer100g": 660,
    "proteinPer100g": 6.9,
    "carbsPer100g": 23.7,
    "fatsPer100g": 64.5,
    "fiberPer100g": 16.3,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F063",
    "nameAr": "زبدة بندق",
    "nameEn": "Hazelnut butter",
    "state": "معجون",
    "caloriesPer100g": 628,
    "proteinPer100g": 15,
    "carbsPer100g": 17,
    "fatsPer100g": 61,
    "fiberPer100g": 9,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F062",
    "nameAr": "زبدة فول سوداني",
    "nameEn": "Peanut butter",
    "state": "معجون",
    "caloriesPer100g": 588,
    "proteinPer100g": 25,
    "carbsPer100g": 20,
    "fatsPer100g": 50,
    "fiberPer100g": 6,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts",
      "peanuts"
    ]
  },
  {
    "id": "F061",
    "nameAr": "سمسم",
    "nameEn": "Sesame seeds",
    "state": "حبوب",
    "caloriesPer100g": 573,
    "proteinPer100g": 17.7,
    "carbsPer100g": 23.4,
    "fatsPer100g": 49.7,
    "fiberPer100g": 11.8,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F060",
    "nameAr": "طحينة سمسم",
    "nameEn": "Tahini",
    "state": "معجون",
    "caloriesPer100g": 595,
    "proteinPer100g": 17,
    "carbsPer100g": 21.2,
    "fatsPer100g": 53.8,
    "fiberPer100g": 9.3,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F067",
    "nameAr": "فستق",
    "nameEn": "Pistachios",
    "state": "نيء",
    "caloriesPer100g": 562,
    "proteinPer100g": 20.2,
    "carbsPer100g": 27.2,
    "fatsPer100g": 45.3,
    "fiberPer100g": 10.6,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F065",
    "nameAr": "لوز محمص",
    "nameEn": "Almonds, roasted",
    "state": "محمص",
    "caloriesPer100g": 598,
    "proteinPer100g": 21,
    "carbsPer100g": 21,
    "fatsPer100g": 53,
    "fiberPer100g": 11,
    "category": "مكسرات وبذور",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F071",
    "nameAr": "طحين جوز الهند",
    "nameEn": "Coconut flour",
    "state": "جاف",
    "caloriesPer100g": 400,
    "proteinPer100g": 20,
    "carbsPer100g": 60,
    "fatsPer100g": 13.3,
    "fiberPer100g": 33.3,
    "category": "طحين",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F070",
    "nameAr": "طحين لوز",
    "nameEn": "Almond flour",
    "state": "جاف",
    "caloriesPer100g": 571,
    "proteinPer100g": 21.4,
    "carbsPer100g": 21.4,
    "fatsPer100g": 50,
    "fiberPer100g": 10.7,
    "category": "طحين",
    "allergens": [
      "nuts"
    ]
  },
  {
    "id": "F084",
    "nameAr": "بروكلي",
    "nameEn": "Broccoli",
    "state": "نيء",
    "caloriesPer100g": 34,
    "proteinPer100g": 2.8,
    "carbsPer100g": 6.6,
    "fatsPer100g": 0.4,
    "fiberPer100g": 2.6,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F077",
    "nameAr": "بصل",
    "nameEn": "Onion",
    "state": "نيء",
    "caloriesPer100g": 40,
    "proteinPer100g": 1.1,
    "carbsPer100g": 9.3,
    "fatsPer100g": 0.1,
    "fiberPer100g": 1.7,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F082",
    "nameAr": "بقدونس",
    "nameEn": "Parsley",
    "state": "نيء",
    "caloriesPer100g": 36,
    "proteinPer100g": 3,
    "carbsPer100g": 6.3,
    "fatsPer100g": 0.8,
    "fiberPer100g": 3.3,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F075",
    "nameAr": "بندورة/طماطم",
    "nameEn": "Tomato",
    "state": "نيء",
    "caloriesPer100g": 18,
    "proteinPer100g": 0.9,
    "carbsPer100g": 3.9,
    "fatsPer100g": 0.2,
    "fiberPer100g": 1.2,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F081",
    "nameAr": "ثوم",
    "nameEn": "Garlic",
    "state": "نيء",
    "caloriesPer100g": 149,
    "proteinPer100g": 6.4,
    "carbsPer100g": 33.1,
    "fatsPer100g": 0.5,
    "fiberPer100g": 2.1,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F083",
    "nameAr": "جرجير",
    "nameEn": "Arugula",
    "state": "نيء",
    "caloriesPer100g": 25,
    "proteinPer100g": 2.6,
    "carbsPer100g": 3.7,
    "fatsPer100g": 0.7,
    "fiberPer100g": 1.6,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F080",
    "nameAr": "جزر",
    "nameEn": "Carrot",
    "state": "نيء",
    "caloriesPer100g": 41,
    "proteinPer100g": 0.9,
    "carbsPer100g": 9.6,
    "fatsPer100g": 0.2,
    "fiberPer100g": 2.8,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F072",
    "nameAr": "خس آيسبرغ (Iceberg)",
    "nameEn": "Iceberg lettuce",
    "state": "نيء",
    "caloriesPer100g": 14,
    "proteinPer100g": 0.9,
    "carbsPer100g": 3,
    "fatsPer100g": 0.1,
    "fiberPer100g": 1.2,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F073",
    "nameAr": "خس روماني",
    "nameEn": "Romaine lettuce",
    "state": "نيء",
    "caloriesPer100g": 17,
    "proteinPer100g": 1.2,
    "carbsPer100g": 3.3,
    "fatsPer100g": 0.3,
    "fiberPer100g": 2.1,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F091",
    "nameAr": "خضار مسلوقة مشكلة",
    "nameEn": "Boiled mixed vegetables",
    "state": "مسلوق",
    "caloriesPer100g": 60,
    "proteinPer100g": 2.5,
    "carbsPer100g": 12,
    "fatsPer100g": 0.5,
    "fiberPer100g": 3.5,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F090",
    "nameAr": "خضار مشكلة",
    "nameEn": "Mixed vegetables",
    "state": "مطبوخ/مشكّل",
    "caloriesPer100g": 65,
    "proteinPer100g": 3,
    "carbsPer100g": 13,
    "fatsPer100g": 0.5,
    "fiberPer100g": 4,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F074",
    "nameAr": "خيار",
    "nameEn": "Cucumber",
    "state": "نيء",
    "caloriesPer100g": 15,
    "proteinPer100g": 0.7,
    "carbsPer100g": 3.6,
    "fatsPer100g": 0.1,
    "fiberPer100g": 0.5,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F085",
    "nameAr": "زهور بروكلي",
    "nameEn": "Broccoli florets",
    "state": "نيء",
    "caloriesPer100g": 34,
    "proteinPer100g": 2.8,
    "carbsPer100g": 6.6,
    "fatsPer100g": 0.4,
    "fiberPer100g": 2.6,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F078",
    "nameAr": "فلفل أخضر رومي",
    "nameEn": "Green bell pepper",
    "state": "نيء",
    "caloriesPer100g": 20,
    "proteinPer100g": 0.9,
    "carbsPer100g": 4.6,
    "fatsPer100g": 0.2,
    "fiberPer100g": 1.7,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F086",
    "nameAr": "قرنبيط/زهرة",
    "nameEn": "Cauliflower",
    "state": "نيء",
    "caloriesPer100g": 25,
    "proteinPer100g": 1.9,
    "carbsPer100g": 5,
    "fatsPer100g": 0.3,
    "fiberPer100g": 2,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F076",
    "nameAr": "كوسا",
    "nameEn": "Zucchini",
    "state": "نيء",
    "caloriesPer100g": 17,
    "proteinPer100g": 1.2,
    "carbsPer100g": 3.1,
    "fatsPer100g": 0.3,
    "fiberPer100g": 1,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F079",
    "nameAr": "مشروم",
    "nameEn": "Mushrooms",
    "state": "نيء",
    "caloriesPer100g": 22,
    "proteinPer100g": 3.1,
    "carbsPer100g": 3.3,
    "fatsPer100g": 0.3,
    "fiberPer100g": 1,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F087",
    "nameAr": "ملفوف أبيض",
    "nameEn": "White cabbage",
    "state": "نيء",
    "caloriesPer100g": 25,
    "proteinPer100g": 1.3,
    "carbsPer100g": 5.8,
    "fatsPer100g": 0.1,
    "fiberPer100g": 2.5,
    "category": "خضار",
    "allergens": [
      "eggs"
    ]
  },
  {
    "id": "F088",
    "nameAr": "ملفوف أحمر",
    "nameEn": "Red cabbage",
    "state": "نيء",
    "caloriesPer100g": 31,
    "proteinPer100g": 1.4,
    "carbsPer100g": 7.4,
    "fatsPer100g": 0.2,
    "fiberPer100g": 2.1,
    "category": "خضار",
    "allergens": []
  },
  {
    "id": "F089",
    "nameAr": "أفوكادو",
    "nameEn": "Avocado",
    "state": "نيء",
    "caloriesPer100g": 160,
    "proteinPer100g": 2,
    "carbsPer100g": 8.5,
    "fatsPer100g": 14.7,
    "fiberPer100g": 6.7,
    "category": "خضار/فاكهة",
    "allergens": []
  },
  {
    "id": "F092",
    "nameAr": "بطاطا نيئة",
    "nameEn": "Potato, raw",
    "state": "نيء",
    "caloriesPer100g": 77,
    "proteinPer100g": 2,
    "carbsPer100g": 17.5,
    "fatsPer100g": 0.1,
    "fiberPer100g": 2.2,
    "category": "نشويات",
    "allergens": []
  },
  {
    "id": "F094",
    "nameAr": "أرز أبيض جاف",
    "nameEn": "White rice, dry",
    "state": "جاف",
    "caloriesPer100g": 365,
    "proteinPer100g": 7.1,
    "carbsPer100g": 80,
    "fatsPer100g": 0.7,
    "fiberPer100g": 1.3,
    "category": "حبوب ونشويات",
    "allergens": [
      "eggs"
    ]
  },
  {
    "id": "F096",
    "nameAr": "أرز كبسة مطبوخ",
    "nameEn": "Kabsa rice, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 180,
    "proteinPer100g": 3.5,
    "carbsPer100g": 28,
    "fatsPer100g": 5.5,
    "fiberPer100g": 0.5,
    "category": "حبوب ونشويات",
    "allergens": []
  },
  {
    "id": "F100",
    "nameAr": "ذرة حلوة",
    "nameEn": "Sweet corn",
    "state": "مطبوخ/مصفى",
    "caloriesPer100g": 86,
    "proteinPer100g": 3.2,
    "carbsPer100g": 18.7,
    "fatsPer100g": 1.2,
    "fiberPer100g": 2,
    "category": "حبوب ونشويات",
    "allergens": []
  },
  {
    "id": "F097",
    "nameAr": "معكرونة جافة",
    "nameEn": "Pasta, dry",
    "state": "جاف",
    "caloriesPer100g": 371,
    "proteinPer100g": 13,
    "carbsPer100g": 74.7,
    "fatsPer100g": 1.5,
    "fiberPer100g": 3.2,
    "category": "حبوب ونشويات",
    "allergens": [
      "gluten"
    ]
  },
  {
    "id": "F098",
    "nameAr": "معكرونة مطبوخة",
    "nameEn": "Pasta, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 158,
    "proteinPer100g": 5.8,
    "carbsPer100g": 30.9,
    "fatsPer100g": 0.9,
    "fiberPer100g": 1.8,
    "category": "حبوب ونشويات",
    "allergens": [
      "gluten"
    ]
  },
  {
    "id": "F101",
    "nameAr": "خبز أبيض",
    "nameEn": "White bread",
    "state": "جاهز",
    "caloriesPer100g": 266,
    "proteinPer100g": 8.9,
    "carbsPer100g": 49.4,
    "fatsPer100g": 3.3,
    "fiberPer100g": 2.7,
    "category": "خبز",
    "allergens": [
      "eggs",
      "gluten"
    ]
  },
  {
    "id": "F102",
    "nameAr": "خبز قمح كامل",
    "nameEn": "Whole-wheat bread",
    "state": "جاهز",
    "caloriesPer100g": 247,
    "proteinPer100g": 12.5,
    "carbsPer100g": 41.4,
    "fatsPer100g": 3.4,
    "fiberPer100g": 6,
    "category": "خبز",
    "allergens": [
      "gluten"
    ]
  },
  {
    "id": "F103",
    "nameAr": "خبز متعدد الحبوب (Multigrain)",
    "nameEn": "Multigrain bread",
    "state": "جاهز",
    "caloriesPer100g": 265,
    "proteinPer100g": 13,
    "carbsPer100g": 43,
    "fatsPer100g": 4.2,
    "fiberPer100g": 6,
    "category": "خبز",
    "allergens": [
      "gluten"
    ]
  },
  {
    "id": "F104",
    "nameAr": "خبز/رقائق حبوب Fitness",
    "nameEn": "Fitness-style whole-grain crackers",
    "state": "جاهز",
    "caloriesPer100g": 430,
    "proteinPer100g": 10,
    "carbsPer100g": 67,
    "fatsPer100g": 12,
    "fiberPer100g": 7,
    "category": "خبز/سناك",
    "allergens": [
      "gluten"
    ]
  },
  {
    "id": "F105",
    "nameAr": "عدس جاف",
    "nameEn": "Lentils, dry",
    "state": "جاف",
    "caloriesPer100g": 352,
    "proteinPer100g": 24.6,
    "carbsPer100g": 63.4,
    "fatsPer100g": 1.1,
    "fiberPer100g": 10.7,
    "category": "بقوليات",
    "allergens": []
  },
  {
    "id": "F106",
    "nameAr": "عدس مطبوخ",
    "nameEn": "Lentils, cooked",
    "state": "مطبوخ",
    "caloriesPer100g": 116,
    "proteinPer100g": 9,
    "carbsPer100g": 20.1,
    "fatsPer100g": 0.4,
    "fiberPer100g": 7.9,
    "category": "بقوليات",
    "allergens": []
  },
  {
    "id": "F107",
    "nameAr": "حبوب كورن فليكس",
    "nameEn": "Corn flakes",
    "state": "جاهز",
    "caloriesPer100g": 357,
    "proteinPer100g": 7.5,
    "carbsPer100g": 84,
    "fatsPer100g": 0.4,
    "fiberPer100g": 3.3,
    "category": "حبوب",
    "allergens": []
  },
  {
    "id": "F108",
    "nameAr": "تفاح",
    "nameEn": "Apple",
    "state": "نيء",
    "caloriesPer100g": 52,
    "proteinPer100g": 0.3,
    "carbsPer100g": 13.8,
    "fatsPer100g": 0.2,
    "fiberPer100g": 2.4,
    "category": "فواكه",
    "allergens": []
  },
  {
    "id": "F109",
    "nameAr": "تفاح أخضر",
    "nameEn": "Green apple",
    "state": "نيء",
    "caloriesPer100g": 52,
    "proteinPer100g": 0.3,
    "carbsPer100g": 13.8,
    "fatsPer100g": 0.2,
    "fiberPer100g": 2.4,
    "category": "فواكه",
    "allergens": []
  },
  {
    "id": "F111",
    "nameAr": "ليمون",
    "nameEn": "Lemon",
    "state": "نيء",
    "caloriesPer100g": 29,
    "proteinPer100g": 1.1,
    "carbsPer100g": 9.3,
    "fatsPer100g": 0.3,
    "fiberPer100g": 2.8,
    "category": "فواكه",
    "allergens": []
  },
  {
    "id": "F110",
    "nameAr": "موز",
    "nameEn": "Banana",
    "state": "نيء",
    "caloriesPer100g": 89,
    "proteinPer100g": 1.1,
    "carbsPer100g": 22.8,
    "fatsPer100g": 0.3,
    "fiberPer100g": 2.6,
    "category": "فواكه",
    "allergens": []
  },
  {
    "id": "F112",
    "nameAr": "عصير ليمون طازج",
    "nameEn": "Lemon juice, fresh",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 22,
    "proteinPer100g": 0.4,
    "carbsPer100g": 6.9,
    "fatsPer100g": 0.2,
    "fiberPer100g": 0.3,
    "category": "مشروبات/إضافات",
    "allergens": []
  },
  {
    "id": "F113",
    "nameAr": "عصير برتقال",
    "nameEn": "Orange juice",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 45,
    "proteinPer100g": 0.7,
    "carbsPer100g": 10.4,
    "fatsPer100g": 0.2,
    "fiberPer100g": 0.2,
    "category": "مشروبات",
    "allergens": []
  },
  {
    "id": "F123",
    "nameAr": "قهوة سوداء محضرة",
    "nameEn": "Brewed black coffee",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 1,
    "proteinPer100g": 0.1,
    "carbsPer100g": 0,
    "fatsPer100g": 0,
    "fiberPer100g": 0,
    "category": "مشروبات",
    "allergens": []
  },
  {
    "id": "F114",
    "nameAr": "خردل أصفر",
    "nameEn": "Yellow mustard",
    "state": "جاهز",
    "caloriesPer100g": 60,
    "proteinPer100g": 3.7,
    "carbsPer100g": 5.8,
    "fatsPer100g": 3.3,
    "fiberPer100g": 4,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F118",
    "nameAr": "دبس رمان",
    "nameEn": "Pomegranate molasses",
    "state": "جاهز",
    "caloriesPer100g": 250,
    "proteinPer100g": 0.5,
    "carbsPer100g": 65,
    "fatsPer100g": 0,
    "fiberPer100g": 0.5,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F116",
    "nameAr": "صلصة طماطم بدون سكر مضاف",
    "nameEn": "Tomato sauce, no added sugar",
    "state": "جاهز",
    "caloriesPer100g": 29,
    "proteinPer100g": 1.4,
    "carbsPer100g": 6.3,
    "fatsPer100g": 0.2,
    "fiberPer100g": 1.5,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F119",
    "nameAr": "صوص BBQ",
    "nameEn": "BBQ sauce",
    "state": "جاهز",
    "caloriesPer100g": 172,
    "proteinPer100g": 1,
    "carbsPer100g": 40,
    "fatsPer100g": 0.6,
    "fiberPer100g": 1,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F117",
    "nameAr": "صوص رانش",
    "nameEn": "Ranch dressing",
    "state": "جاهز",
    "caloriesPer100g": 430,
    "proteinPer100g": 1.5,
    "carbsPer100g": 7,
    "fatsPer100g": 44,
    "fiberPer100g": 0.3,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F115",
    "nameAr": "كاتشب",
    "nameEn": "Ketchup",
    "state": "جاهز",
    "caloriesPer100g": 112,
    "proteinPer100g": 1.3,
    "carbsPer100g": 26.7,
    "fatsPer100g": 0.2,
    "fiberPer100g": 0.3,
    "category": "صوصات وإضافات",
    "allergens": []
  },
  {
    "id": "F124",
    "nameAr": "بيكنغ باودر",
    "nameEn": "Baking powder",
    "state": "مسحوق",
    "caloriesPer100g": 53,
    "proteinPer100g": 0,
    "carbsPer100g": 28,
    "fatsPer100g": 0,
    "fiberPer100g": 0.2,
    "category": "مكونات جافة",
    "allergens": []
  },
  {
    "id": "F120",
    "nameAr": "كاكاو غير محلى",
    "nameEn": "Unsweetened cocoa powder",
    "state": "مسحوق",
    "caloriesPer100g": 228,
    "proteinPer100g": 19.6,
    "carbsPer100g": 57.9,
    "fatsPer100g": 13.7,
    "fiberPer100g": 37,
    "category": "مكونات جافة",
    "allergens": []
  },
  {
    "id": "F121",
    "nameAr": "قرفة",
    "nameEn": "Ground cinnamon",
    "state": "مسحوق",
    "caloriesPer100g": 247,
    "proteinPer100g": 4,
    "carbsPer100g": 80.6,
    "fatsPer100g": 1.2,
    "fiberPer100g": 53.1,
    "category": "توابل",
    "allergens": []
  },
  {
    "id": "F127",
    "nameAr": "ملح",
    "nameEn": "Salt",
    "state": "جاف",
    "caloriesPer100g": 0,
    "proteinPer100g": 0,
    "carbsPer100g": 0,
    "fatsPer100g": 0,
    "fiberPer100g": 0,
    "category": "توابل",
    "allergens": []
  },
  {
    "id": "F128",
    "nameAr": "ملح وردي",
    "nameEn": "Himalayan pink salt",
    "state": "جاف",
    "caloriesPer100g": 0,
    "proteinPer100g": 0,
    "carbsPer100g": 0,
    "fatsPer100g": 0,
    "fiberPer100g": 0,
    "category": "توابل",
    "allergens": []
  },
  {
    "id": "F122",
    "nameAr": "فانيلا مستخلص",
    "nameEn": "Vanilla extract",
    "state": "سائل",
    "unitLabel": "مل",
    "unitName": "مل",
    "unit": "ml",
    "isLiquid": true,
    "caloriesPer100g": 288,
    "proteinPer100g": 0.1,
    "carbsPer100g": 12.7,
    "fatsPer100g": 0.1,
    "fiberPer100g": 0,
    "category": "نكهات",
    "allergens": []
  },
  {
    "id": "F126",
    "nameAr": "إريثريتول",
    "nameEn": "Erythritol",
    "state": "مسحوق",
    "caloriesPer100g": 20,
    "proteinPer100g": 0,
    "carbsPer100g": 100,
    "fatsPer100g": 0,
    "fiberPer100g": 0,
    "category": "محليات",
    "allergens": []
  },
  {
    "id": "F125",
    "nameAr": "ستيفيا نقية",
    "nameEn": "Pure stevia sweetener",
    "state": "مسحوق",
    "caloriesPer100g": 0,
    "proteinPer100g": 0,
    "carbsPer100g": 0,
    "fatsPer100g": 0,
    "fiberPer100g": 0,
    "category": "محليات",
    "allergens": []
  }
];
